// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3YfXL","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1l4NW","obliqueLine":"membershipbadge_obliqueLine__3fxfY"};